module.exports = __webpack_public_path__ + "static/edit-home1-fullwidth-banner-b694d8dfe5b2630dd961fa6be0bdcb4d.png";